/**
 * Product Reviews Section Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to Product Reviews section.
 *
 * @namespace productReviews
 */

 
  window.theme = window.theme || {};  
  window.theme.components = window.theme.components || {}; 
  theme.components.productReviews = { 
		cloneOkendoElements: function () {
			const observer = new MutationObserver((mutations, obs) => {
			const okendoRating = document.querySelector('.oke-w-ratingAverageModule-rating');
			const okendoButton = document.querySelector('.oke-w-reviews-writeReview .oke-w-writeReview');
			const okendoCount = document.querySelector('.oke-sr-count-number')?.innerHTML;
			const reviewsContentTop = document.querySelector('.product-reviews__overlay-top');
			const reviewsContentBottom = document.querySelector('.product-reviews__overlay-bottom');
			const reviewsContentCount = document.querySelector('.product-reviews__count');
			const reviewsRating = okendoRating?.cloneNode(true);
			const reviewsButton = okendoButton?.cloneNode(true);
			let reviewsButtonHref = reviewsButton?.href;

			reviewsButtonHref = reviewsButtonHref.includes('cloudfront.net') ? `https://okendo.reviews${reviewsButtonHref.split('cloudfront.net')[1]}` : reviewsButtonHref;

			
			reviewsButton.classList.add('button');
			reviewsButton.classList.add('button--quaternary');

			reviewsButton.href = reviewsButtonHref;

			reviewsRating.innerHTML = reviewsRating.innerHTML.replaceAll('oke-star-empty', 'oke-star-empty-light');
			reviewsRating.innerHTML = reviewsRating.innerHTML.replaceAll('oke-star-filled', 'oke-star-filled-light'); 

			reviewsContentCount.innerHTML = `Based on ${okendoCount} reviews`;

			if (okendoRating) {
				reviewsContentTop.append(reviewsRating);
				reviewsContentBottom.append(reviewsButton);
				obs.disconnect();
				return;
			}

		});
		observer.observe(document, { 
			childList: true,
			subtree: true
		});
	}
}

  theme.components.productReviews.cloneOkendoElements();
